export default __webpack_public_path__ + "static/media/at.66c25985.svg";